import { render, staticRenderFns } from "./CmgHeader.vue?vue&type=template&id=c5f200ac&scoped=true&lang=pug"
import script from "./cmg-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHeader.vue?vue&type=style&index=0&id=c5f200ac&prod&lang=scss&scoped=true"
import style1 from "./CmgHeader.vue?vue&type=style&index=1&id=c5f200ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f200ac",
  null
  
)

export default component.exports